import { gql } from '@apollo/client';
const UPDATE_TENANT_CATEGORY = gql `
  mutation UpdateTenantCategory($categoryId: ID!, $name: String!, $image: String) {
    updateModelSpecificationCategory(
      modelSpecificationCategoryId: $categoryId
      name: $name
      image: $image
    ) {
      modelSpecificationCategory {
        id
        name
        image
      }
    }
  }
`;
export default UPDATE_TENANT_CATEGORY;
